<template>
  <div class="p-6 bg-gray-100 min-h-screen">
    <div class="mb-6">
      <div class="bg-white rounded-xl shadow-md p-6 flex items-center justify-between">
        <div>
          <span class="text-xl font-bold text-purple-600 inline-block transition-all duration-500">
            <span
                class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 hover:animate-pulse">
              {{ user.name }}
            </span>
          </span>
          <span class="text-xl font-bold text-gray-800 mr-2">خوش آمدید</span>
          <p class="text-gray-500 mt-2">سطح دسترسی:
            <span class="text-green-500 mr-1 font-weight-bold"> ادمین بسته بندی</span>
          </p>
        </div>
        <div class="text-right">
          <div class="inline-flex items-center gap-2">
            <div class="relative h-6 w-6 flex items-center mt-1">
              <svg class="absolute h-7 w-7 text-green-500 animate-spin opacity-100 verification-spinner"
                   xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
               <svg class="absolute h-7 w-7 text-green-500 opacity-0 verification-check"
                     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                </svg>
              </div>
            <p class="text-md mt-5  font-weight-bold text-green-500">توکن معتبر</p>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-6">
      <div class="bg-gradient-to-r from-purple-500 to-blue-500 rounded-xl shadow-lg p-6 flex items-center justify-between text-white">
        <div class="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          <div>
            <p class="text-sm opacity-80">موجودی کیف پول کاربران</p>
            <p class="text-2xl font-bold">{{ balance | toMoney }} <span class="text-sm">تومان</span></p>
          </div>
        </div>
        <div class="bg-white bg-opacity-20 rounded-full p-2">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
      </div>
    </div>
    <orders-total></orders-total>
    <shop-orders-list-table></shop-orders-list-table>
  </div>
</template>

<script>
import Chart from 'chart.js';
import ShopOrdersListTable from "@/modules/order_admin/ShopOrdersList";
import OrdersTotal from "@/modules/order_admin/OrdersTotal";

export default {
  name: "OrdersDashboard",
  components: {OrdersTotal, ShopOrdersListTable},
  data() {
    return {
      balance: 0,
    };
  },
  mounted() {
    this.updateBalance()

  },
  methods: {
    updateBalance() {
      this.request({
        url: this.endpoint('finance/walletsBalanceSum'),
        method: "get",
        success: data => {
          this.balance = data.total_balance
          console.log(data)
        }
      })
    },
  }
};
</script>

<style scoped>
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
  transform-origin: center;
}

/* For your verification animation */
.verification-spinner {
  animation: spin 1s linear infinite, verification 2s linear infinite;
}

.verification-check {
  animation: check-animation 2s linear infinite;
}

@keyframes verification {
  0%, 45% { opacity: 1; }
  50%, 100% { opacity: 0; }
}

@keyframes check-animation {
  0%, 45% { opacity: 0; }
  50%, 100% { opacity: 1; }
}
canvas {
  width: 100% !important;
  height: 240px !important;
}
</style>
